import $ from '@js/modules/selector';

import {showSignupModal} from '@js/actions/userActions';
import {addToBasket} from '@js/actions/basketActions';

import {userStore} from '@js/stores/userStore';
import {basketStore} from '@js/stores/basketStore';

import {videoLazyLoader} from '@js/modules/videoLazyLoader';

import {checkoutPath} from '@js/constants/routesHelper';

import AnalyticsService from '@js/modules/analyticsService';


class ProductManager {
    _basketButtonIds = [
        '#add-basket-main',
        '#add-basket-bottom'
    ];

    _basketErrorId = '#basket-error';

    _basketErrorContentId = '#basket-error-content';

    _videoModalId = '#feature-video-modal';

    _videoPlayerId = '#feature-video-player';

    /* Public methods
    ******************** */
    initialize = () => {
        videoLazyLoader();

        this._handleAddToBasketClick();
        this._initializeFeatureVideoModal();
    };

    /* Private methods
    ******************** */
    _enableBasketButtons = () => {
        this._basketButtonIds.forEach((buttonId) => {
            const $addBasketButton = $(buttonId);
            const $addBasketLoader = $(buttonId + '-loader');

            if ($addBasketButton) {
                $addBasketButton.removeAttr('disabled');
            }

            if ($addBasketLoader) {
                $addBasketLoader.addClass('hidden');
                $addBasketLoader.removeClass('inline');
            }
        });
    };

    _disableBasketButtons = () => {
        this._basketButtonIds.forEach((buttonId) => {
            const $addBasketButton = $(buttonId);
            const $addBasketLoader = $(buttonId + '-loader');

            if ($addBasketButton) {
                $addBasketButton.attr('disabled', 'disabled');
            }

            if ($addBasketLoader) {
                $addBasketLoader.removeClass('hidden');
                $addBasketLoader.addClass('inline');
            }
        });
    };

    _addToBasket = (productId) => {
        addToBasket(productId, 'product_page')
            .then((response) => {
                const $basketError = $(this._basketErrorId);

                if (response.errors) {
                    const $basketErrorContent = $(this._basketErrorContentId);

                    if ($basketError) {
                        $basketError.removeClass('hidden');
                        $basketErrorContent.html(Array.isArray(response.errors) ? response.errors.join(', ') : response.errors);
                    }

                    this._enableBasketButtons();

                    return;
                } else if ($basketError) {
                    $basketError.addClass('hidden');
                }

                const basket = response.basket;
                const product = basket?.products?.first();

                basketStore.basket = basket;

                setTimeout(() => this._enableBasketButtons(), 500);

                AnalyticsService.trackAddToBasket(product.slug, product.name, basket.totalAmount)
                    .then(() => {
                        if (userStore.isConnected) {
                            window.location = checkoutPath();
                        } else {
                            userStore.redirectionURL = checkoutPath();

                            userStore.quickSave = true;
                            userStore.state.signupModal?.updateOnHide(() => {
                                userStore.quickSave = false;
                            });

                            showSignupModal();
                        }
                    });
            });
    };

    _handleAddToBasketClick = () => {
        this._basketButtonIds.forEach((buttonId) => {
            const $addBasketButton = $(buttonId);
            if (!$addBasketButton) {
                return;
            }

            $addBasketButton.on('click', (event) => {
                event.preventDefault();

                this._disableBasketButtons();

                const productId = $addBasketButton.data('product-id');

                this._addToBasket(productId);
            });
        });
    };

    _initializeFeatureVideoModal = () => {
        const modal = document.getElementById(this._videoModalId.substring(1));
        const videoPlayer = document.getElementById(this._videoPlayerId.substring(1));

        if (!modal || !videoPlayer) return;

        const closeBtn = modal.querySelector('.feature-video-modal-close');
        const overlay = modal.querySelector('.feature-video-modal-overlay');

        // Fonction pour ouvrir la modal avec une vidéo
        const openVideoModal = (webmSrc, mp4Src) => {
            // Mettre à jour les sources de la vidéo
            videoPlayer.innerHTML = `
                <source src="${webmSrc}" type="video/webm">
                <source src="${mp4Src}" type="video/mp4">
            `;

            // Charger et lire la vidéo
            videoPlayer.load();
            videoPlayer.play().catch(() => {
                // Ignorer les erreurs de lecture automatique
            });

            // Afficher la modal avec animation
            modal.classList.remove('hidden');
            requestAnimationFrame(() => {
                modal.classList.add('show');
            });

            // Empêcher le scroll du body
            document.body.style.overflow = 'hidden';
        };

        // Fonction pour fermer la modal
        const closeVideoModal = () => {
            modal.classList.remove('show');
            setTimeout(() => {
                modal.classList.add('hidden');
                videoPlayer.pause();
                videoPlayer.innerHTML = '';
            }, 300);

            // Réactiver le scroll du body
            document.body.style.overflow = '';
        };

        // Event listeners pour les boutons vidéo
        document.querySelectorAll('.feature-video-btn').forEach(btn => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                const webmSrc = btn.dataset.videoWebm;
                const mp4Src = btn.dataset.videoMp4;
                if (webmSrc && mp4Src) {
                    openVideoModal(webmSrc, mp4Src);
                }
            });
        });

        // Fermer la modal
        if (closeBtn) {
            closeBtn.addEventListener('click', closeVideoModal);
        }
        if (overlay) {
            overlay.addEventListener('click', closeVideoModal);
        }

        // Fermer avec la touche Escape
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && modal.classList.contains('show')) {
                closeVideoModal();
            }
        });
    };
}

export default new ProductManager();
